import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// app.js
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueMaterialIcon from "vue-material-icon";
import "font-awesome/css/font-awesome.min.css";
import * as VueGoogleMaps from "vue2-google-maps";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import "./assets/css/custom.scss";
import wb from "./registerServiceWorker";
import VueI18n from "vue-i18n";
import { messages } from "./utils/language";
Vue.use(VueI18n);
Vue.prototype.$workbox = wb;

Vue.use(VueToast, {
  duration: 4000
});

const i18n = new VueI18n({
  locale: localStorage.getItem("defaultLang"),
  messages
});

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component(VueMaterialIcon.name, VueMaterialIcon);
Vue.use(require("vue-moment"));
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBmS9QQWofTpIbYDpWebbUP9lhbBBW5raA",
    libraries: "places"
  }
});

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");




// const prod = process.env.NODE_ENV === "production";
// const shouldSW = "serviceWorker" in navigator && prod;
// const shouldSWDev = "serviceWorker" in navigator && !prod;

// if (shouldSW) {
  // navigator.serviceWorker.register("/service-worker.js").then(() => {
  //   console.log("Service Worker Registered!");
  // });
// } else if (shouldSWDev) {
//   console.log("IIIIIIIII", shouldSWDev,navigator.serviceWorker);
//   navigator.serviceWorker.register("/service-worker-dev.js").then(() => {
//     console.log("Service Worker Registered!");
//   });
// }
